<script setup lang="ts">
// The iconic YouTube play badge — red rounded rectangle + white triangle.
// Used as the "watch on YouTube" affordance on video thumbnails. The badge is
// brand-fixed (YouTube red + white), so colors are baked in, not tinted via
// `currentColor`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="28"
    height="20"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M27.4 3.12a3.49 3.49 0 0 0-2.46-2.47C22.77 0.07 14 0.07 14 0.07s-8.77 0-10.94.58A3.49 3.49 0 0 0 0.6 3.12C0.02 5.3 0.02 10 0.02 10s0 4.7.58 6.88a3.49 3.49 0 0 0 2.46 2.47C5.23 19.93 14 19.93 14 19.93s8.77 0 10.94-.58a3.49 3.49 0 0 0 2.46-2.47C27.98 14.7 27.98 10 27.98 10s0-4.7-.58-6.88Z"
      fill="#FF0000"
    />
    <path d="M11.2 14.29 18.48 10 11.2 5.71v8.58Z" fill="#FFFFFF" />
  </svg>
</template>
